<p class="c-title">Filtrar</p>
<div class="c-input-container">
  <input [(ngModel)]="value" (blur)="tocar()" [disabled]="disabled" type="search"
    class="c-input-container__input form-control" placeholder="Pesquisar...">
  <button class="c-input-container__button" (click)="buscar.emit()">Buscar</button>
  <ng-content></ng-content>
</div>